module.exports = __webpack_public_path__ + "static/media/2DGACM10.0082bb59.jpg";